import React from "react";
import "./error.css";

const Error = () => {
  return (
    <div className="error-page">
      <h1>404 Error</h1>
    </div>
  );
};

export default Error;
